module.exports = __webpack_public_path__ + "img/rundale.87135c99.png";